import { removeNotification, resetClearNotifications } from '@va/dashboard/actions/ui';
import { getNotification, needToClearNotifications } from '@va/dashboard/selectors/ui';
import { useTranslate } from '@va/localization';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Toaster } from 'sonner';
import { NotificationItem } from './types';
import { useNotificationSystem } from './useNotificationSystem';

export default function NotificationSystemComponent() {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const { addNotification, clearNotifications } = useNotificationSystem();

  const notification = useSelector(getNotification) as NotificationItem | null;
  const clearNotificationsRequested = useSelector(needToClearNotifications) as boolean;

  useEffect(() => {
    if (notification) {
      // Clear existing notifications before showing the new one
      clearNotifications();
      const processedNotification = {
        ...notification,
        title: notification.title ? translate(notification.title as string) : notification.title,
      };
      addNotification(processedNotification);
      dispatch(removeNotification());
    }
  }, [addNotification, clearNotifications, dispatch, notification, translate]);

  useEffect(() => {
    if (clearNotificationsRequested) {
      clearNotifications();
      dispatch(resetClearNotifications());
    }
  }, [clearNotifications, clearNotificationsRequested, dispatch]);

  return (
    <Toaster
      closeButton={false}
      offset={{ right: 0, top: '6rem' }}
      mobileOffset={{ right: 0, top: '5rem' }}
      style={{ border: 0, backgroundColor: '#000624' }}
    />
  );
}
